import { Button, styled } from '@mui/material'
import { memo } from 'react'

export const StyledMaxButton = styled(Button)`
  height: 24px;
  padding: 0;
  font-weight: 400;
  padding: 0 8px;
  font-size: 14px;
  margin-right: 8px;
  color: ${({ theme }) => theme.color.text100};
  border: 1px solid rgba(46, 54, 59, 1);
  border-radius: 12px;
  &:hover {
    color: rgba(160, 238, 9, 1);
    background-color: transparent;
    border-color: rgba(160, 238, 9, 1);
  }
`

export const MaxButton = memo<{ onClick(): void }>(({ onClick }) => {
  return <StyledMaxButton onClick={onClick}>Max</StyledMaxButton>
})
